<template>
  <div>
    <el-steps
      direction="vertical"
      class="step"
      finish-status="success"
      process-status="finish"
      :active="active"
    >
      <!-- 1 -->
      <el-step :title="$t('common.flowStatus.uploading')"></el-step>
      <!-- 2 -->
      <el-step :title="$t('common.flowStatus.processing')"></el-step>
      <!-- 3 -->
      <el-step :title="$t('common.flowStatus.manualChecking')"></el-step>
      <!-- 4 -->
      <el-step v-if="status === 4" :title="$t('common.flowStatus.rejected')"></el-step>
      <!-- 4 -->
      <el-step :title="$t('common.flowStatus.approved')"></el-step>
      <!-- 5 -->
      <el-step :title="$t('common.flowStatus.warehousing')"></el-step>
      <!-- 6 -->
      <el-step v-if="status === 1" :title="$t('common.flowStatus.pending')"></el-step>
      <!-- 7 -->
      <el-step :title="$t('common.flowStatus.online')"></el-step>
      <!-- 8 -->
      <el-step v-if="status === 2" :title="$t('common.flowStatus.takeDown')"></el-step>
    </el-steps>
    <div class="center">
      <el-button type="ghost" @click="handleClose">关 闭</el-button>
    </div>
  </div>
</template>

<script>

const statusToStep = {
  1: 5,
  2: 6,
  3: 2,
  4: 3,
  5: 5,
}
export default {
  name: 'InsertFlow',
  props: {
    status: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      active: 0
    }
  },
  created() {
    this.active = statusToStep[this.status]
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.step {
  margin: 0 0 20px 40px;
  height: 400px;
}
</style>
